import {
  ArrowRightIcon,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  InfoCardList,
  InfoCardProps,
  useRouter,
} from '@forgeglobal/design-framework'
import { Routes } from 'util/Routes'
import { formatAbbreviatedMoney, formatSharePrice } from 'util/NumberUtils'
import { isNotCancelledOrClosed } from 'util/OpportunityUtils'
import { useMinimalOpportunitiesQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'
import capitalize from 'lodash/capitalize'
import moment from 'moment'

const LatestOpportunities: React.FC<{ openSidebar: () => void }> = ({ openSidebar }) => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useMinimalOpportunitiesQuery({ variables: { accountId: match.params.id } })
  const opportunities = data?.account?.opportunities ?? []
  const dataList = opportunities
    .filter(isNotCancelledOrClosed)
    .map<InfoCardProps>(opp => {
      return {
        logo: opp.company.logo_url,
        leftTitle: opp.company.name,
        leftSubtitle: capitalize(opp.trade_intent.type),
        rightTitle: formatAbbreviatedMoney(opp.trade_intent.dollar_amount) || '–',
        rightSubtitle: opp.trade_intent.share_price
          ? `${formatSharePrice(opp.trade_intent.share_price)} / per share`
          : '–',
        notes: `Created ${moment(opp.created_at).fromNow()}` || '',
        link: Routes.opportunity(opp.id),
      }
    })
    .slice(0, 2)

  return (
    <Card>
      <CardHeader
        title="Latest Opportunities"
        action={
          <IconButton onClick={openSidebar}>
            <ArrowRightIcon />
          </IconButton>
        }
      />
      <CardContent>
        <InfoCardList items={dataList} />
      </CardContent>
    </Card>
  )
}

export { LatestOpportunities }
